import { render, staticRenderFns } from "./TemplateSelectComponent.vue?vue&type=template&id=366b8c00"
import script from "./TemplateSelectComponent.vue?vue&type=script&lang=js"
export * from "./TemplateSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports